import React, {Component} from 'react';
import {ListGroup} from 'reactstrap';
import TemplateCategory from 'template/components/TemplateCategory';

export default class TemplateCategoryList extends Component {
    render() {
        const {
            templateCategoryList
        } = this.props;
        return (
            <ListGroup>
                {
                    templateCategoryList.map(
                        (templateCategory, index) => (
                            <TemplateCategory
                                index={index + 1}
                                key={`template_category_${templateCategory.id}`}
                                templateCategory={templateCategory}/>
                        )
                    )
                }
            </ListGroup>
        )
    }
}
